"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Bookmark = _interopRequireDefault(require("@material-ui/icons/Bookmark"));
var _BookmarkBorder = _interopRequireDefault(require("@material-ui/icons/BookmarkBorder"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    wrapper: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 36,
      height: 36
    },
    iconBg: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: 36,
      color: theme.palette.secondary.main,
      pointerEvents: "none",
      zIndex: 1
    },
    iconBtn: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: 24,
      color: theme.palette.externo.main,
      cursor: "pointer",
      zIndex: 2,
      transition: "transform 0.2s ease-in-out",
      "&:hover": {
        transform: "translate(-50%, -50%) scale(1.2)"
      }
    },
    iconBtnUnchecked: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: 24,
      color: theme.palette.externo.main,
      cursor: "pointer",
      zIndex: 2,
      transition: "transform 0.2s ease-in-out",
      "&:hover": {
        transform: "translate(-50%, -50%) scale(1.2)"
      }
    }
  };
});
var SttFavoritar = function SttFavoritar(_ref) {
  var situacaoCurso = _ref.situacaoCurso,
    tenho_interesse = _ref.tenho_interesse,
    onClick = _ref.onClick,
    naoComplementados = _ref.naoComplementados,
    situacaoInscricao = _ref.situacaoInscricao;
  var classes = useStyles();
  if (naoComplementados) {
    return null;
  }
  var deveExibir = situacaoCurso === "NI" || situacaoCurso === "A" && situacaoInscricao === "A";
  if (!deveExibir) {
    return null;
  }
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper
  }, tenho_interesse ? /*#__PURE__*/_react["default"].createElement(_Bookmark["default"], {
    className: classes.iconBtn,
    onClick: handleClick
  }) : /*#__PURE__*/_react["default"].createElement(_BookmarkBorder["default"], {
    className: classes.iconBtnUnchecked,
    onClick: handleClick
  }));
};
var _default = SttFavoritar;
exports["default"] = _default;